export default __webpack_public_path__ + "static/media/amazon.f7ac2aae.png";